import React, { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const SPOverview = ({ data, from }) => {
  /* 
    Header data
  */

  const userId = Cookies.get('userId');

  // Track component mount

  // Track page view
  useEffect(() => {
    mixpanel.track('SP Overview Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    mixpanel.track('SP Overview Viewed', {
      user_id: userId,
      sp_id: data?.id,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  return (
    <div className="overflow-y-auto w-full mb-7">
      <div className="mx-auto flex flex-col gap-1">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 mb-1">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-3 flex-1 pt-4 pb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0">
                {from === 'payables'
                  ? data?.user?.name?.charAt(0)?.toUpperCase() || 'L'
                  : data?.vendor?.user?.name?.charAt(0)?.toUpperCase() || 'L'}
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 flex-1">
                <div className="flex items-center gap-2">
                  <div className="min-w-0">
                    <p className="font-bold text-gray-900 text-sm truncate">
                      {from === 'payables' ? data?.user?.name : data?.vendor?.user?.name || '---'}
                    </p>
                    <p className="text-gray-500 text-xs">SP ID: {data?.id}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg
                      className="w-4 h-4 text-blue-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      />
                    </svg>
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs text-gray-600">Phone</p>
                    <p className="font-medium text-gray-900 truncate text-sm">
                      {from === 'payables'
                        ? data?.user?.phone_number
                        : data?.vendor?.user?.phone_number || '---'}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs text-gray-600">Email</p>
                    <p className="font-medium text-gray-900 truncate text-sm">
                      {from === 'payables' ? data?.user?.email : data?.vendor?.user?.email || '---'}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                      />
                    </svg>
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs text-gray-600">Project</p>
                    <p className="font-medium text-gray-900 truncate text-sm">
                      {data?.project?.name || '---'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SPOverview;
